// @flow
import React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-flexbox-grid';
import {
  MdClose,
} from 'react-icons/lib/md';
import {
  reduxForm,
  Field,
} from 'redux-form';
import i18n from 'i18n-js';

import {
  onSubmit,
  validate,
} from './utils';
import PopupHeader from '../../PopupHeader';
import PopupHeaderRightGroup from '../../PopupHeaderRightGroup';
import PopupHeaderLeftGroup from '../../PopupHeaderLeftGroup';
import PopupContent from '../../PopupContent';
import PopupFooter from '../../PopupFooter';
import PopupHeaderTitle from '../../PopupHeaderTitle';
import Button from '../../Button';
import PopupCloseButton from '../../PopupCloseButton';
import {
  RenderInput,
} from '../../FieldRenderer';
import SwitchLabel from '../../SwitchLabel';

import { Cancel, CreateButton } from '../../CommonTexts';
import styles from '../../CreateExitMethodPopupContent/CreateExitMethodPopupForm/createExitMethodPopupForm.css';


type CreateGatePopupFormPropTypes = {
  handleSubmit: Function,
};

const CreateGatePopupForm = ({
  handleSubmit,
}: CreateGatePopupFormPropTypes) => (
  <form id="createRoute" onSubmit={handleSubmit}>
    <PopupHeader size="small">
      <PopupHeaderLeftGroup>
        <PopupHeaderTitle title={CreateButton(i18n.t('common.gate', { count: 1 }))} size="big" />
      </PopupHeaderLeftGroup>
      <PopupHeaderRightGroup>
        <PopupCloseButton
          size="medium"
          Icon={MdClose}
          tint="mediumGray"
          clearMargins
          isTransparent
          isOutlined
        />
      </PopupHeaderRightGroup>
    </PopupHeader>
    <PopupContent className={styles.CreateGatePopupContent} size="small">
      <Grid>
        <Row>
          <Col xs={7}>
            <Field
              name="name"
              label={i18n.t('labels.name', { count: 1 })}
              placeholder="ie. Puerta 2, Fuente"
              component={RenderInput}
              type="text"
              autoFocus
            />
          </Col>
          <Col xs={3} xsOffset={0}>
            <SwitchLabel
              text={i18n.t('gateways.creatingGate')}
              fontSize="medium"
            />
          </Col>
          <Col xs={2}>
            <Field
              name="ordinal"
              label="&nbsp;"
              placeholder="01"
              component={RenderInput}
              type="text"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className={styles.spacer} />
          </Col>
        </Row>
      </Grid>
    </PopupContent>
    <PopupFooter size="small">
      <PopupCloseButton title={Cancel()} tint="paleGray" />
      <Button type="submit" title={CreateButton(i18n.t('common.gate', { count: 1 }))} />
    </PopupFooter>
  </form>
);

export default connect(
  undefined,
  undefined,
)(reduxForm({
  form: 'createGate',
  onSubmit,
  validate,
})(CreateGatePopupForm));



// WEBPACK FOOTER //
// ./src/scripts/components/CreateGatePopupContent/CreateGatePopupForm/index.jsx